export class LoadCodeModel {
    appt_proc_id: number
    appt_proc_name: string
    appt_proc_code: string
    appt_max: number

    constructor(
        appt_proc_id: number,
        appt_proc_name: string,
        appt_proc_code: string,
        appt_max: number
    ) {
        this.appt_proc_id = appt_proc_id
        this.appt_proc_name = appt_proc_name
        this.appt_proc_code = appt_proc_code
        this.appt_max = appt_max
    }
}